(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["case-study"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('case-study-layout')) {
    customElements.define('case-study-layout', class extends HTMLElement {
      connectedCallback() {
        const root = this.closest('.case-study') || this;
        const links = Array.from(root.querySelectorAll('[data-case-study-link]'));
        const current = this.querySelector('[data-case-study-current]');
        const ids = [...new Set(links.map((link) => link.hash.slice(1)))];
        const sections = ids.map((id) => document.getElementById(id)).filter(Boolean);
        if (!sections.length || !('IntersectionObserver' in window)) return;

        const setCurrent = (id) => links.forEach((link) => {
          if (link.hash === `#${id}`) {
            link.setAttribute('aria-current', 'true');
            if (current) current.textContent = link.textContent;
          } else {
            link.removeAttribute('aria-current');
          }
        });

        this.observer = new IntersectionObserver((entries) => {
          const visible = entries.filter((entry) => entry.isIntersecting);
          if (visible.length) setCurrent(visible[0].target.id);
        }, { rootMargin: '-20% 0px -70% 0px' });
        sections.forEach((section) => this.observer.observe(section));
        setCurrent(sections[0].id);

        this.querySelectorAll('.case-study__mobile-toc a').forEach((link) => {
          link.addEventListener('click', () => link.closest('details').removeAttribute('open'));
        });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    });
  }

  if (!customElements.get('case-study-gallery')) {
    customElements.define('case-study-gallery', class extends HTMLElement {
      connectedCallback() {
        this.thumbs = Array.from(this.querySelectorAll('.case-study__thumb'));
        this.thumbs.forEach((thumb, index) => {
          thumb.addEventListener('click', () => this.select(index));
          thumb.addEventListener('keydown', (event) => {
            const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[event.key];
            if (!step) return;
            event.preventDefault();
            const next = (index + step + this.thumbs.length) % this.thumbs.length;
            this.select(next);
            this.thumbs[next].focus();
          });
        });
      }

      select(index) {
        this.thumbs.forEach((thumb, i) => {
          const selected = i === index;
          thumb.setAttribute('aria-pressed', String(selected));
          document.getElementById(thumb.getAttribute('aria-controls')).hidden = !selected;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
